import React, { useEffect, useRef, useState } from "react";
import TeamsHeader from "../../MenuEchoPulse/TeamsHeader";
import SingleMemberTaskViewHeader from "../../MenuEchoPulse/SingleMemberTaskViewHeader";
import { CustomDateTimePicker } from "../../../components/DateTimePicker/DatePicker";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import {
  convertHourMinuteToMinutes,
  convertMinutesToHoursAndMinutes,
  convertUTCtoIST,
  formatDate,
  formatPushDate,
  formatRelativeTime,
} from "../../../utils/common";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  addTaskByAdminAsync,
  addTimeByAdminAsync,
  deleteCommentAsync,
  getTimesheetByIdAsync,
  updateAdminTaskAsync,
  updateTimesheetByAdminAsync,
} from "../../../services/reducers/teamsReducer";
import Button from "../../../components/Button/Button";
// import AddTaskModal from "../../TimeTracker/AddTaskModal";
import Notification from "../../../components/Notification/Notification";
import Icons from "../../../components/Icons/Icon";
import myTeamImage from "../../../images/Profile.png";
import Textarea from "../../../components/TextArea/Textarea";
import ActionDropdownSm from "../../../components/ActionDropdown/ActionDropdownSm";
import SingleMemberTaskViewNoteModal from "./SingleMemberTaskViewNoteModal";
import PushBackConfirmation from "./confirmModal/PushBackConfirmation";
import ApproveConfirmation from "./confirmModal/ApproveConfirmation";
import {
  getUserIdentityAsync,
  getUserProfileAsync,
  getUsersAsync,
} from "../../../services/reducers/appReducer";
import UserImage from "../../../components/UserImage/UserImage";
import getInitialsInName from "../../../helper/GetNameInitials";
import ModalDelete from "../../TimeTracker/ModalDeletePopup";
import { toast } from "react-toastify";
import { TOASTIFY_CONF } from "../../../services/sharedService/constants";
import CustomTooltip from "../../TimeTracker/CustomTooltip";
import { useLocation } from "react-router-dom";
import { getSettingListAsync } from "../../../services/reducers/adminReducer";
import Tooltip from "../../../components/Tooltip/Tooltip";
import AddTaskModal from "../../TimeTracker/AddTaskModal";

export const EchoPulseDatePicker = styled.div`
  overflow: hidden;
  .react-datepicker__calendar-icon {
    display: none;
  }

  // .react-datepicker-wrapper {
  //   width: 9.5rem;
  // }

  .react-datepicker-wrapper input {
    padding: 0.531rem 0.625rem;
    width: 100%;
    font-size: 0.875rem;
    font-weight: 400;
    color: #232323;
    border: 0.063rem solid #d9d9d9;
    border-radius: 0.375rem;
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z' fill='%23292D32'/%3E%3Cpath d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z' fill='%23292D32'/%3E%3Cpath d='M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z' fill='%23292D32'/%3E%3Cpath d='M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z' fill='%23292D32'/%3E%3Cpath d='M8.5 14.5C8.37 14.5 8.24 14.47 8.12 14.42C8 14.37 7.89001 14.3 7.79001 14.21C7.70001 14.11 7.62999 14 7.57999 13.88C7.52999 13.76 7.5 13.63 7.5 13.5C7.5 13.24 7.61001 12.98 7.79001 12.79C7.89001 12.7 8 12.63 8.12 12.58C8.3 12.5 8.50001 12.48 8.70001 12.52C8.76001 12.53 8.82 12.55 8.88 12.58C8.94 12.6 9 12.63 9.06 12.67C9.11 12.71 9.15999 12.75 9.20999 12.79C9.24999 12.84 9.29999 12.89 9.32999 12.94C9.36999 13 9.40001 13.06 9.42001 13.12C9.45001 13.18 9.47001 13.24 9.48001 13.3C9.49001 13.37 9.5 13.43 9.5 13.5C9.5 13.76 9.38999 14.02 9.20999 14.21C9.01999 14.39 8.76 14.5 8.5 14.5Z' fill='%23292D32'/%3E%3Cpath d='M12 14.5C11.74 14.5 11.48 14.39 11.29 14.21C11.25 14.16 11.21 14.11 11.17 14.06C11.13 14 11.1 13.94 11.08 13.88C11.05 13.82 11.03 13.76 11.02 13.7C11.01 13.63 11 13.57 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.57 12.51 12.02 12.42 12.38 12.58C12.51 12.63 12.61 12.7 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.57 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.79 14.11 12.75 14.16 12.71 14.21C12.61 14.3 12.51 14.37 12.38 14.42C12.26 14.47 12.13 14.5 12 14.5Z' fill='%23292D32'/%3E%3Cpath d='M8.5 18C8.37 18 8.24 17.97 8.12 17.92C8 17.87 7.89001 17.8 7.79001 17.71C7.70001 17.61 7.62999 17.51 7.57999 17.38C7.52999 17.26 7.5 17.13 7.5 17C7.5 16.74 7.61001 16.48 7.79001 16.29C7.89001 16.2 8 16.13 8.12 16.08C8.49 15.92 8.92999 16.01 9.20999 16.29C9.24999 16.34 9.29999 16.39 9.32999 16.44C9.36999 16.5 9.40001 16.56 9.42001 16.62C9.45001 16.68 9.47001 16.74 9.48001 16.81C9.49001 16.87 9.5 16.94 9.5 17C9.5 17.26 9.38999 17.52 9.20999 17.71C9.01999 17.89 8.76 18 8.5 18Z' fill='%23292D32'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: center;
    cursor: pointer;
  }

  .react-datepicker-wrapper input:focus {
    border: 0.063rem solid #4a154b;
    box-shadow: 0 0.625rem 1.25rem 0 rgba(0, 0, 0, 0.08);
    outline: 0;
  }
  .monthlyDate .react-datepicker-popper {
    width: max-content;
  }
  .monthlyDate .react-datepicker__month-text {
    padding: 0.9rem 0;
    width: 5.1rem;
    display: inline-block;
    font-size: 0.875rem;
    margin: 0.125rem;
  }
  .monthlyDate .react-datepicker__month-text--keyboard-selected {
    background-color: #f8f8f8;
    color: #000;
    font-weight: bolder;
  }
  .monthlyDate .react-datepicker__header {
    background-color: #fff;
    border: none;
    padding-top: 1.25rem;
  }
  .monthlyDate .react-datepicker__navigation {
    align-items: center;
    display: flex;
    padding: 0;
    text-align: center;
    top: 1.063rem;
  }
  .monthlyDate .react-datepicker__navigation--previous {
    left: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation--next {
    rigth: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation-icon:before {
    border-color: #232323;
    border-width: 0.094rem 0.094rem 0 0;
  }
  .monthlyDate .react-datepicker__day--in-range {
    background-color: #f15845;
  }
  .monthlyDate .react-datepicker__day--keyboard-selected {
    color: #fff;
  }
  .monthlyDate .react-datepicker__day--today {
    font-weight: 800;
  }
  .react-datepicker__month-text--in-range {
    background-color: #f15845;
  }
`;

type CommentMap = {
  [timeSheetId: string]: string[];
};

const SingleMemberTaskView = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const today = new Date();
  const dayOfWeek = today.getDay();
  const startOfWeeks = new Date(today);
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - ((dayOfWeek + 6) % 7));
  const [startDate, setStartDate] = useState(startOfWeek);
  const [endDate, setEndDate] = useState(() => {
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    return endOfWeek;
  });
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const [showNotification1, setShowNotification1] = useState<boolean>(false);
  const [singleNote, setSingleNote] = useState<boolean>(false);
  const [showNotificationLock, setShowNotificationLock] =
    useState<boolean>(false);
  const [list, setList] = useState<any>([]);
  const [addTask, setAddTask] = useState<boolean>(false);
  const [taskList, setTaskList] = useState<any>([]);
  const processedDates = new Set();
  const isWeekend = (dateString: any) => {
    const date = new Date(dateString);
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6;
  };
  const [showClickShow, setShowClickShow] = useState({ taskId: "", date: "" });
  const [pushBackConfirm, setPushBackConfirm] = useState<boolean>(false);
  const [approveConfirm, setApproveConfirm] = useState<boolean>(false);
  const [comment, setComment] = useState<string>("");
  // const [comments, setComments] = useState<CommentMap>({});
  const { userProfile } = useAppSelector((state: any) => state.app);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [timesheetId, setTimesheetId] = useState<string>("");
  const [userLists, setUserLists] = useState<any>(null);
  const [commentId, setCommentId] = useState("");
  const [isConfirmationVisible, setConfirmationVisible] = useState(false);
  const [isPushback, setIsPushback] = useState(false);
  const [timeoffList, setTimeoffList] = useState<any>([]);
  const totalHoursPerDay: { [date: string]: number } = {};
  const hasPushTimesheet = list.some((t: any) => t.timeSheetActionStatus === 1);
  const isFetching = useRef(false);
  const { state } = useLocation();
  const getSettingList = useAppSelector(
    (state: any) => state.admin.getSettingList?.records
  );
  const [userDetail, setUserDetail] = useState<any>(null);
  const [comments, setComments] = useState<{
    [key: string]: { text: string; time: string }[];
  }>({});
  const [noteDetails, setNoteDetails] = useState({
    summary: "",
    projectKey: "",
    projectId: "",
    projectName: "",
    key: "",
    timesheetId: "",
  });

  useEffect(() => {
    if (state) {
      //console.log('Received state:', state);
      setStartDate(new Date(state.startDate));
      setEndDate(new Date(state.endDate));
    }
  }, [state]);

  useEffect(() => {
    getUserIdentity();
  }, [id]);

  const getUserIdentity = () => {
    // console.log(id, "id");
    dispatch(getUserIdentityAsync(id)).then((res) => {
      if (res.payload) {
        setUserDetail(res.payload);
      }
    });
  };

  useEffect(() => {
    dispatch(getSettingListAsync());
  }, []);

  const toggleClickShow = (taskId: string, date: string) => {
    setShowClickShow((prevState) => {
      if (prevState.taskId === taskId && prevState.date === date) {
        return { taskId: "", date: "" };
      }
      return { taskId, date };
    });
  };

  const closeClickShow = () => {
    setShowClickShow({ taskId: "", date: "" });
  };

  const filterFutureDates = (date: Date) => {
    const today = new Date();
    return date <= today;
  };

  const onChangeDate = (value: any) => {
    if (!value || !value[0]) {
      return;
    }
    const selectedDate = value[0];
    if (!selectedDate || typeof selectedDate.getDay !== "function") {
      return;
    }
    const dayOfWeek = selectedDate.getDay();
    const startOfWeek = new Date(selectedDate);
    startOfWeek.setDate(selectedDate.getDate() - ((dayOfWeek + 6) % 7));

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    setStartDate(startOfWeek);
    setEndDate(endOfWeek);
  };

  useEffect(() => {
    getteambyList();
  }, [startDate, endDate]);

  const getteambyList = () => {
    const request: any = {
      StartDate: formatDate(startDate),
      EndDate: formatDate(endDate),
      MemberId: id,
      PageSize: 100,
      Page: 1,
    };

    request.SelectedStartDate = formatDate(startDate);
    request.SelectedEndDate = formatDate(endDate);

    dispatch(getTimesheetByIdAsync(request)).then((res) => {
      if (res.payload) {
        const filteredList = res.payload.item1.records.map((record: any) => {
          const filteredTasks = record.tasksList.filter((task: any) => {
            const recordDate = new Date(task.date);

            const isAfterStartDate =
              recordDate.getFullYear() > startDate.getFullYear() ||
              (recordDate.getFullYear() === startDate.getFullYear() &&
                recordDate.getMonth() > startDate.getMonth()) ||
              (recordDate.getFullYear() === startDate.getFullYear() &&
                recordDate.getMonth() === startDate.getMonth() &&
                recordDate.getDate() >= startDate.getDate());

            const isBeforeEndDate =
              recordDate.getFullYear() < endDate.getFullYear() ||
              (recordDate.getFullYear() === endDate.getFullYear() &&
                recordDate.getMonth() < endDate.getMonth()) ||
              (recordDate.getFullYear() === endDate.getFullYear() &&
                recordDate.getMonth() === endDate.getMonth() &&
                recordDate.getDate() <= endDate.getDate());

            return isAfterStartDate && isBeforeEndDate;
          });

          return {
            ...record,
            tasksList: filteredTasks,
          };
        });

        setList(filteredList);
        setTaskList(filteredList.flatMap((t: any) => t.tasksList));
        setTimeoffList(
          res.payload.item1.records[0].tasksList.flatMap((t1: any) => t1.timeOffList)
        );
      }
    });
  };

  list.forEach((task: any) => {
    task.tasksList.forEach((t: any) => {
      const date = t.date;
      totalHoursPerDay[date] = (totalHoursPerDay[date] || 0) + t.timeSpent;
    });
  });

  const getParentTimeEstimate = (
    targetDate: string,
    targetTimesheetId: string
  ) => {
    for (const parentTask of list) {
      for (const task of parentTask.tasksList) {
        if (
          task.date === targetDate &&
          task.timeSheetId === targetTimesheetId
        ) {
          const editableDiv = document.getElementsByClassName(
            `test${targetDate}_${targetTimesheetId}`
          );
          if (parentTask.timeEstimate === 0 && editableDiv.length > 0) {
            Array.from(editableDiv).forEach((editableDivElement: Element) => {
              if (editableDivElement instanceof HTMLElement) {
                editableDivElement.textContent = "-";
              }
            });
          }

          return parentTask.timeEstimate;
        }
      }
    }
    return 0;
  };

  const handleTimeSpentEdit = (
    taskId: string,
    date: string,
    timeSheetId: string,
    newValue: number
  ) => {
    const updatedList = list.map((task: any) => {
      if (task.identifier === taskId) {
        const updatedTasksList = task.tasksList.map((t1: any) => {
          if (t1.date === date) {
            return { ...t1, timeSpent: newValue || 0 };
          }
          return t1;
        });

        return { ...task, tasksList: updatedTasksList };
      }
      return task;
    });

    const updatedTask = updatedList.find(
      (task: any) => task.identifier === taskId
    );
    const values = {
      timeSheetId: timeSheetId,
      date: date,
      //estimateTime: 0,
      timeSpent: convertHourMinuteToMinutes(
        `${updatedTask?.tasksList.find((t1: any) => t1.date === date)
          ?.timeSpent || "00h00m00s"
        }`
      ),
      identifier: taskId,
      memberId: id,
    };

    const content =
      values.timeSpent > 0
        ? convertMinutesToHoursAndMinutes(values.timeSpent)
        : "-";

    const editableDiv = document.getElementById(`test${timeSheetId}`);
    if (editableDiv) {
      editableDiv.textContent = content;
    }
    dispatch(updateTimesheetByAdminAsync(values)).then((res) => {
      // dispatch(updateAdminTaskAsync(values)).then((res) => {
      getteambyList();
    });
  };

  // const handleInput = (e: any) => {
  //   const selection = window.getSelection();
  //   const anchorOffset = selection?.anchorOffset || 0;
  //   const validInput = e.currentTarget.textContent;

  //   if (validInput === "-") {
  //     e.currentTarget.textContent = "";
  //     return;
  //   }

  //   if (selection) {
  //     const firstChild = e.currentTarget.firstChild;

  //     if (firstChild) {
  //       const range = document.createRange();
  //       const offset = Math.min(anchorOffset, validInput.length);
  //       range.setStart(firstChild, offset);
  //       range.setEnd(firstChild, offset);
  //       selection.removeAllRanges();
  //       selection.addRange(range);
  //     }
  //   }

  //   if (validInput !== "") {
  //     e.currentTarget.textContent = validInput;
  //   }
  // };

  const handleInput = (e: any) => {
    const selection = window.getSelection();
    const anchorOffset = selection?.anchorOffset || 0;
    const currentValue = e.currentTarget.textContent;

    // Sanitize input to allow only numbers, 'h', 'm', and spaces
    const sanitizedInput = currentValue.replace(/[^0-9hm\s]/g, "");

    // Set sanitized input back to the element
    e.currentTarget.textContent = sanitizedInput;

    // Ensure the caret remains at the correct position
    if (selection) {
      const firstChild = e.currentTarget.firstChild;
      if (firstChild) {
        const range = document.createRange();
        const offset = Math.min(anchorOffset, sanitizedInput.length);
        range.setStart(firstChild, offset);
        range.setEnd(firstChild, offset);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  };

  const onFocus = (e: any) => {
    if (e.currentTarget.textContent === "-") {
      e.currentTarget.textContent = "";
    }

    e.currentTarget.dataset.prevValue = e.currentTarget.textContent.trim();
  };

  const onBlur = (
    e: any,
    taskId: string,
    key: string,
    date: string,
    timeSheetId: string,
    projectStatus: number,
    platform: number,
    projectId: string,
    projectKey: string,
    projectName: string,
    estimate: number,
    taskSummary: string
  ) => {
    const inputValue = e.currentTarget.textContent.trim();
    const prevValue = e.currentTarget.dataset.prevValue;

    if (inputValue === "-") {
      e.currentTarget.textContent = "";
    }

    if (timeSheetId === "00000000-0000-0000-0000-000000000000") {
      const request = {
        weekStartDate: date,
        //logDate:date,
        tasks: {
          identifier: taskId,
          key: key,
          project: {
            id: projectId,
            externalId: "",
            key: projectKey,
            name: projectName,
            projectStatus: projectStatus,
            platform: platform,
            deleted: false,
          },
          summary: taskSummary,
          timeEstimate: estimate,
          entryFrom: 0
        },
        platformId: platform,
        memberId: id,

      };
      dispatch(addTimeByAdminAsync(request)).then((response) => {
        // dispatch(addTaskByAdminAsync(request)).then((response) => {
        const newTimeSheetId = response.payload.timeSheetId;
        if (inputValue !== prevValue) {
          const newValue = inputValue === "" ? 0 : inputValue;
          const editableDiv = document.getElementById(`test${newTimeSheetId}`);

          if (editableDiv) {
            editableDiv.textContent =
              inputValue !== ""
                ? convertMinutesToHoursAndMinutes(newValue)
                : "-";
          } else {
            console.warn(`Element with id 'test${newTimeSheetId}' not found`);
          }

          handleTimeSpentEdit(taskId, date, newTimeSheetId, newValue);
        } else {
          if (inputValue === "") {
            e.currentTarget.textContent = "-";
          } else {
            e.currentTarget.textContent = prevValue;
          }
        }
      });
    } else {
      if (inputValue !== prevValue) {
        const newValue = inputValue === "" ? 0 : inputValue;
        const editableDiv = document.getElementById(`test${timeSheetId}`);

        if (editableDiv) {
          editableDiv.textContent =
            inputValue !== "" ? convertMinutesToHoursAndMinutes(newValue) : "-";
        }

        handleTimeSpentEdit(taskId, date, timeSheetId, newValue);
      } else {
        // If the field is clicked outside without any value, show the hyphen
        if (inputValue === "") {
          e.currentTarget.textContent = "-";
        } else {
          e.currentTarget.textContent = prevValue;
        }
      }
    }
  };

  // const handleSendComment = (taskId: string) => {
  //   console.log(taskId, "")
  //   if (comment.trim() === "") return;

  //   const currentTime = formatCurrentTime();

  //   setComments((prevComments) => {
  //     const taskComments = prevComments[taskId] || [];
  //     return {
  //       ...prevComments,
  //       [taskId]: [...taskComments, { text: comment, time: currentTime }],
  //     };
  //   });

  //   setComment("");
  // };

  const handleSendComment = (taskId: string, t1: any, estimate: number, summary: string, identifier: string, key: string) => {
    // console.log(t1, "detail");

    if (comment.trim() === "") return;

    const currentTime = formatCurrentTime();

    if (taskId === "00000000-0000-0000-0000-000000000000") {
      const request = {
        weekStartDate: t1.date,
        tasks: {
          identifier: identifier,
          key: key,
          project: {
            id: t1.project.id,
            externalId: "",
            key: t1.project.key,
            name: t1.project.name,
            projectStatus: t1.project.projectStatus,
            platform: t1.project.platform,
            deleted: false,
          },
          summary: summary,
          timeEstimate: estimate,
          entryFrom: 0,
        },
        platformId: t1.project.platform,
        memberId: id,
      };

      dispatch(addTimeByAdminAsync(request)).then((response) => {
        const newTimeSheetId = response.payload.timeSheetId;
        setComments((prevComments) => {
          const taskComments = prevComments[newTimeSheetId] || [];
          return {
            ...prevComments,
            [newTimeSheetId]: [...taskComments, { text: comment, time: currentTime }],
          };
        });

        setComment("");
      });
    } else {
      setComments((prevComments) => {
        const taskComments = prevComments[taskId] || [];
        return {
          ...prevComments,
          [taskId]: [...taskComments, { text: comment, time: currentTime }],
        };
      });

      setComment("");
    }
  };

  const formatCurrentTime = () => {
    const currentTime = new Date();
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  const hasApproveTimesheet = list.some(
    (t: any) => t.timeSheetActionStatus !== 2
  );

  const handleDelete = (id: string) => {
    setConfirmationVisible(true);
    setCommentId(id);
  };

  const hasApprovedTimesheet = list.some(
    (t: any) => t.timeSheetActionStatus === 2
  );
  const hasSubmittedTimesheet = list.some(
    (t: any) => t.timeSheetActionStatus === 0
  );
  const handleDeleteComment = (timeSheetId: any, commentIndex: any) => {
    const updatedComments = { ...comments };
    updatedComments[timeSheetId].splice(commentIndex, 1);
    toast.success(`Comment Deleted Successfully`, TOASTIFY_CONF);
    setComments(updatedComments);
  };

  const hasTimesheet = list.some((t: any) => t.timeSheetActionStatus === null);

  let taskTotal = 0;
  let isFirstTask = true;

  list.forEach((task: any) => {
    let taskTime = 0;
    task.tasksList.forEach((item: any) => {
      taskTime += item.timeSpent;
      // console.log(`Adding time spent for ${item.date}: ${item.timeSpent} minutes`);

      item.timeOffList.forEach((timeOff: any) => {
        if (isFirstTask) {
          if (!isWeekend(timeOff.timeOffDate)) {
            taskTime += timeOff.approvedTimeOffInMin;
            console.log(
              `Adding time off for ${timeOff.timeOffDate}: ${timeOff.approvedTimeOffInMin} minutes`
            );
          }
        }
      });
    });

    // console.log(`Total time for task ${task.key}: ${taskTime} minutes`);
    taskTotal += taskTime;

    if (isFirstTask) {
      isFirstTask = false;
    }
  });

  const handleNotesWrapper = (
    summary: string,
    projectKey: string,
    projectId: string,
    projectName: string,
    key: string,
    timesheetId: string
  ) => {
    setNoteDetails({
      summary,
      projectKey,
      projectId,
      projectName,
      key,
      timesheetId,
    });
    setSingleNote(true);
  };

  const timesheetActions = list.map(
    (record: any) => record.timeSheetActionStatus
  );
  const lastAction = timesheetActions[timesheetActions.length - 1];

  return (
    <div>
      <SingleMemberTaskViewHeader userDetail={userDetail} />
      <div className="flex justify-between items-center">
        <div className="ps-1 text-400 font-bold text-gray-300 relative after:absolute after:-bottom-[1.75rem] after:left-1 after:bg-primary-100 after:h-0.5 after:w-full after:rounded-t-md" id="teamSingleMemberView">
          Weekly
        </div>
        <div className="flex justify-end items-center gap-3">
          <EchoPulseDatePicker>
            <div className="w-[9.5rem] monthlyDate">
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={onChangeDate}
                dateFormat="dd MMM"
                showIcon
                filterDate={filterFutureDates}
                onFocus={(e: any) => e.target.blur()}
              />
            </div>
          </EchoPulseDatePicker>
          {!hasSubmittedTimesheet &&
            // !(
            //   userProfile?.roleName === "Employee" &&
            //   userProfile?.isReportingManager
            // ) &&
            !hasPushTimesheet &&
            !hasApprovedTimesheet && (
              <Button
                className="!px-6"
                label="Add Time"
                variant="primary"
                size="extramedium"
                onClick={() => setAddTask(true)}
              />
            )}
        </div>
      </div>

      <div className="border border-gray-100 shadow-300 rounded-md relative h-[calc(100vh-11.75rem)] flex flex-col flex-grow mt-4 $">
        <div
          className={`bg-white relative min-h-[8rem] pb-6 flex-grow rounded-md overflow-auto ${(userProfile?.roleName === "Admin" &&
            userProfile?.isReportingManager === true) ||
            userProfile?.isReportingManager === true
            ? "h-[calc(100%-5.563rem)]"
            : "h-[100%] rounded-b-md"
            }`}
        >
          <div className="h-[4rem] bg-gray-200 rounded-t-md sticky left-0 top-0 z-50 px-6">
            <div className="flex justify-start gap-2 h-full">
              <div className="flex items-center justify-start w-[calc(100%-44rem)]">
                <div className="text-400 font-bold text-gray-300">Tasks</div>
              </div>

              <div className="flex justify-end text-center gap-[0.75rem]">
                {taskList.map((task: any) => {
                  const currentDate = task.date;
                  const isToday =
                    new Date(currentDate).toLocaleDateString() ===
                    new Date().toLocaleDateString();
                  const dayKey = `${currentDate}_${new Date(
                    currentDate
                  ).toLocaleDateString("en-US", { weekday: "short" })}`;

                  if (processedDates.has(dayKey)) {
                    return null;
                  }

                  processedDates.add(dayKey);
                  const isWeekendWithTimeSpent =
                    isWeekend(currentDate) &&
                    taskList.some(
                      (t: any) => t.date === currentDate && t.timeSpent > 0
                    );

                  return (
                    <div
                      key={currentDate}
                      className={`flex justify-center items-center w-[5rem] h-full relative ${isToday
                        ? "after:absolute after:left-1/2 after:-translate-x-1/2 after:top-0 after:bg-primary-100 after:h-[0.188rem] after:w-9 after:rounded-b-md"
                        : ""
                        } ${isWeekend(currentDate)
                          ? isWeekendWithTimeSpent
                            ? "opacity-100"
                            : "opacity-50"
                          : ""
                        }`}
                    >
                      <div>
                        <div className={`text-500 font-bold text-gray-300`}>
                          {new Date(currentDate).toLocaleDateString("en-US", {
                            weekday: "short",
                          })}
                        </div>
                        <div className={`text-400 font-normal text-gray-300`}>
                          {new Date(currentDate).toLocaleDateString("en-US", {
                            day: "2-digit",
                            month: "short",
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="flex justify-end items-center w-[5rem] h-full">
                  <div>
                    <div className="text-500 font-bold text-gray-300">
                      Total
                    </div>
                    <div className="text-400 font-normal text-gray-300">
                      Hours
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="min-h-[4rem] w-full sticky left-0 top-[4rem] z-50 px-6 bg-white">
            <div className="flex justify-start gap-2 h-full min-h-[4rem] border-b border-gray-400">
              <div className="flex items-center justify-start w-[calc(100%-44rem)] h-full py-[1.063rem]">
                <div className="">Total hours</div>
              </div>
              <div className="flex justify-end text-center gap-[0.75rem] py-[1.063rem]">
                {Object.keys(totalHoursPerDay).map((date) => {
                  const isTimeOffRequested =
                    timeoffList &&
                    timeoffList.some(
                      (timeOffItem: any) => timeOffItem.timeOffDate === date
                    );

                  const timeOffItems = timeoffList.filter(
                    (item: any) => item.timeOffDate === date
                  );

                  const getClassNames = (type: any) => {
                    switch (type) {
                      case "Holiday":
                        return "font-bold text-primary-100";
                      case "Leave":
                        return "font-bold text-secondary-100";
                      default:
                        return "font-normal text-gray-300";
                    }
                  };

                  // const totalApprovedTimeOffInMin = timeOffItems.reduce(
                  //   (acc: any, curr: any) => acc + curr.approvedTimeOffInMin,
                  //   0
                  // );
                  
                  let totalApprovedTimeOffInMin = 0;
                  if (!isWeekend(date)) {
                    console.log(timeOffItems,"timeOffItems")
                    const holidayItem = timeOffItems.find(
                      (item: any) => item.timeOffType === "Holiday"
                    );
                    const leaveItem = timeOffItems.find(
                      (item: any) => item.timeOffType === "Leave"
                    );
                
                    
                    if (holidayItem && leaveItem) {
                      totalApprovedTimeOffInMin = holidayItem.approvedTimeOffInMin;
                    } else {
                      
                      totalApprovedTimeOffInMin = timeOffItems.reduce(
                        (acc: any, curr: any) => acc + curr.approvedTimeOffInMin,
                        0
                      );
                    }
                  }

                  const timeOffType =
                    timeOffItems.length > 0
                      ? timeOffItems[0].timeOffType
                      : null;

                  return (
                    <div
                      key={date}
                      className={`flex justify-center items-center w-[5rem] h-full ${isTimeOffRequested ? "relative" : "overflow-hidden"
                        }`}
                    >
                      <div className={`text-400 ${getClassNames(timeOffType)}`}>
                        {isTimeOffRequested ? (
                          <CustomTooltip
                            tooltipType={timeOffType}
                            trigger
                            timeoffList={timeoffList}
                            date={date}
                          >
                            {/* <div
                              className={`text-400 font-bold ${getClassNames(
                                timeOffType
                              )}`}
                            > */}
                            <div className="text-400 font-bold text-secondary-100">
                              {convertMinutesToHoursAndMinutes(
                                totalApprovedTimeOffInMin +
                                totalHoursPerDay[date]
                              )}
                            </div>
                            {/* <div
                              className={`text-100 font-normal text-center line-clamp-1 ${getClassNames(
                                timeOffType
                              )}`}
                            > */}
                            <div className="text-100 text-center line-clamp-1 font-bold text-secondary-100">
                              {timeOffType === "Holiday"
                                ? "HOLIDAY"
                                : "ON LEAVE"}
                            </div>
                          </CustomTooltip>
                        ) : (
                          convertMinutesToHoursAndMinutes(
                            totalHoursPerDay[date]
                          )
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="flex justify-end items-center w-[5rem] h-full">
                  <div className="text-400 font-bold text-primary-100">
                    {/* {convertMinutesToHoursAndMinutes(
                      list.reduce((total: number, d: any) => {
                        return (
                          total +
                          d.tasksList.reduce(
                            (taskTotal: number, t: any) =>
                              taskTotal + (t.timeSpent > 0 ? t.timeSpent : 0),
                            0
                          )
                        );
                      }, 0)
                    )} */}
                    {convertMinutesToHoursAndMinutes(taskTotal)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {list &&
            list.map(
              (t: any) =>
                t.identifier !== "" && (
                  <div className="h-[4.875rem] relative w-full px-6 after:absolute after:h-9 after:w-[0.1875rem] after:bg-green-100 after:top-1/2 after:-translate-y-1/2 after:left-0 after:rounded-e-md group gap-2 block">
                    <div className="flex justify-start gap-2 h-full min-h-[5rem] border-b border-gray-400">
                      <div className="flex items-center justify-start w-[calc(100%-44rem)] h-full py-[1.063rem]">
                        <div className="">
                          <div className="flex items-center text-400 font-bold text-gray-300">
                            <span className="line-clamp-1">{t.summary}</span>
                          </div>
                          <div className="text-200 text-gray-700 font-normal line-clamp-1 w-full">
                            {t.tasksList[0]?.project?.key ||
                              t.tasksList[0]?.project?.id}{" "}
                            - {t.tasksList[0]?.project?.name} | #{t.key}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end text-center gap-[0.75rem] py-[1.063rem] relative">
                        {t.tasksList.map((t1: any, index: number) => (
                          <>
                            <div
                              key={t1.date}
                              className={`group/openIoconBox clickCommentArea relative flex justify-center items-center w-[5rem] h-full border border-gray-400 rounded-md cursor-pointer hover:border-secondary-100 focus-within:border-green-100 ${
                                // (t1.isDisabled === true) ||
                                hasPushTimesheet ||
                                  hasApprovedTimesheet ||
                                  hasSubmittedTimesheet
                                  // ||
                                  // (userProfile?.roleName === "Employee" &&
                                  //   userProfile?.isReportingManager)
                                  ? "bg-gray-800 bg-opacity-10 cursor-auto hover:border-0 focus-within:border-0"
                                  : ""
                                }`}
                            >
                              <div
                                key={`test${t1.date}`}
                                id={`test${t1.timeSheetId}`}
                                className={`text-400 font-normal text-gray-300 outline-0 focus-visible:outline-none w-full h-full py-3 overflow-hidden test${t1.date}_${t1.timeSheetId}`}
                                //contentEditable={t1.isDisabled === true || !t.isTaskOpen ? false : true}
                                contentEditable={
                                  hasPushTimesheet ||
                                    hasApprovedTimesheet ||
                                    hasSubmittedTimesheet
                                    // ||
                                    // (userProfile?.roleName === "Employee" &&
                                    //   userProfile?.isReportingManager)
                                    ? false
                                    : true
                                }
                                onInput={
                                  t1?.project?.projectStatus === 4
                                    ? () => setShowNotificationLock(true)
                                    : t.isTaskOpen
                                      ? (e: any) => {
                                        handleInput(e);
                                        const estimate = getParentTimeEstimate(
                                          t1.date,
                                          t1.timeSheetId
                                        );
                                        setShowNotification(
                                          estimate === 0 ? true : false
                                        );
                                      }
                                      : t.isTaskOpen === false
                                        ? () => setShowNotification1(true)
                                        : undefined
                                }
                                onFocus={
                                  t1.timeSpent > 0
                                    ? (e: any) => {
                                      onFocus(e);
                                      setShowNotification(false);
                                      setShowNotification1(false);
                                    }
                                    : undefined
                                }
                                onBlur={
                                  t.isTaskOpen
                                    ? (e: any) => {
                                      onBlur(
                                        e,
                                        t.identifier,
                                        t.key,
                                        t1.date,
                                        t1.timeSheetId,
                                        t1?.project?.projectStatus,
                                        t1?.project?.platform,
                                        t1?.project?.id,
                                        t1?.project?.key,
                                        t1?.project?.name,
                                        t?.timeEstimate,
                                        t?.summary
                                      );
                                      setShowNotification(false);
                                      setShowNotification1(false);
                                    }
                                    : undefined
                                }
                              >
                                {t1.timeSpent > 0
                                  ? convertMinutesToHoursAndMinutes(
                                    t1.timeSpent
                                  )
                                  : "-"}
                              </div>
                              {showClickShow.taskId === t1.timeSheetId &&
                                showClickShow.date === t1.date && (
                                  <div className="showCommentArea cursor-auto absolute top-[110%] border border-gray-100 rounded-md w-[23.125rem] bg-white z-10 last:right-0">
                                    <div className="ps-2.5 pe-4 pt-2 pb-2.5 w-full">
                                      <div className="border-b border-gray-100 w-full flex justify-between items-center px-2 pb-1.5">
                                        <div className="text-gray-300 text-500 font-bold">
                                          Add a comment
                                        </div>
                                        <button onClick={closeClickShow}>
                                          <Icons
                                            name="cross"
                                            variant="stroke"
                                            size={16}
                                          />
                                        </button>
                                      </div>
                                    </div>
                                    <div className="max-h-[8rem] overflow-auto">
                                      {t1?.comments?.length > 0 && (
                                        <div className="pb-1 ps-2.5 pe-4 ">
                                          {t1?.comments.map(
                                            (t2: any, index: number) => (
                                              <div
                                                key={t1.date}
                                                className="pt-3 pb-4 border-b border-gray-400"
                                              >
                                                <div className="flex justify-between items-center">
                                                  <div className="flex justify-start items-center gap-2.5">
                                                    <div>
                                                      {userProfile?.profileImagePath ? (
                                                        <UserImage
                                                          imgKey={
                                                            userProfile.profileImagePath
                                                          }
                                                          className="w-8 h-8 rounded-full object-cover"
                                                        />
                                                      ) : (
                                                        <img
                                                          src={getInitialsInName(
                                                            userProfile?.name ??
                                                            "N A",
                                                            24
                                                          )}
                                                          alt={
                                                            userProfile?.name
                                                          }
                                                          className="w-8 h-8 rounded-full object-cover"
                                                        />
                                                      )}
                                                    </div>
                                                    <div className="text-400 font-normal text-gray-300">
                                                      {userProfile?.name}
                                                    </div>
                                                    <div className="text-gray-700 text-400 font-normal">
                                                      {convertUTCtoIST(
                                                        t2.postedAt
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <ActionDropdownSm
                                                      defaultValue="Delete Comment"
                                                      isLastOptionRed
                                                      onSelect={() =>
                                                        handleDelete(t2.id)
                                                      }
                                                      options={[
                                                        {
                                                          label:
                                                            "Delete Comment",
                                                          value:
                                                            "Delete Comment",
                                                        },
                                                      ]}
                                                      value=""
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mt-3 text-gray-300 text-400 text-left">
                                                  {t2.comment}
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}

                                      <div className="pb-1 ps-2.5 pe-4">
                                        {!isPushback &&
                                          comments[t1.timeSheetId]?.map(
                                            (commentObj, idx) => (
                                              <div
                                                key={idx}
                                                className="pt-3 pb-4 border-b border-gray-400"
                                              >
                                                <div className="flex justify-between items-center">
                                                  <div className="flex justify-start items-center gap-2.5">
                                                    <div>
                                                      {userProfile?.profileImagePath ? (
                                                        <UserImage
                                                          imgKey={
                                                            userProfile.profileImagePath
                                                          }
                                                          className="w-8 h-8 rounded-full object-cover"
                                                        />
                                                      ) : (
                                                        <img
                                                          src={getInitialsInName(
                                                            userProfile?.name ??
                                                            "N A",
                                                            24
                                                          )}
                                                          alt={
                                                            userProfile?.name
                                                          }
                                                          className="w-8 h-8 rounded-full object-cover"
                                                        />
                                                      )}
                                                    </div>
                                                    <div className="text-400 font-normal text-gray-300">
                                                      {userProfile?.name}
                                                    </div>
                                                    <div className="text-gray-700 text-400 font-normal">
                                                      {commentObj.time}
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <ActionDropdownSm
                                                      defaultValue="Delete Comment"
                                                      isLastOptionRed
                                                      onSelect={() =>
                                                        handleDeleteComment(
                                                          t1.timeSheetId,
                                                          idx
                                                        )
                                                      }
                                                      options={[
                                                        {
                                                          label:
                                                            "Delete Comment",
                                                          value:
                                                            "Delete Comment",
                                                        },
                                                      ]}
                                                      value=""
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mt-3 text-gray-300 text-400 text-left">
                                                  {commentObj.text}
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </div>
                                    </div>
                                    <div
                                      className="ps-2.5 pe-4 pt-2 pb-2.5"
                                      id={`comments_${t1.timeSheetId}`}
                                    >
                                      {/* <div className="relative [&>div>textarea]:h-[2.5rem] [&>div>textarea]:py-2 [&>div>textarea]:pe-7"> */}
                                      <div className="relative">
                                        <textarea
                                          className="outline-none w-full bg-white border border-gray-100 px-4 py-2 pe-7 text-400 font-normal rounded-md text-gray-300 placeholder:text-gray-700 
                                        focus:border-secondary-100 focus:shadow-200
                                        disabled:bg-gray-200 h-[2.5rem] resize-none"
                                          onChange={(e: any) =>
                                            setComment(e.target.value)
                                          }
                                          placeholder="Add a Comment"
                                          value={comment}
                                          maxLength={100}
                                        // maxCharacters={20}
                                        />
                                        <button
                                          className="absolute right-3 top-3 [&>span>svg>path]:fill-secondary-100 hover:[&>span>svg>path]:fill-secondary-200 z-10"
                                          onClick={() =>
                                            handleSendComment(t1.timeSheetId, t1, t?.timeEstimate,
                                              t?.summary, t.identifier, t.key)
                                          }
                                        >
                                          <Icons
                                            name="send"
                                            variant="stroke"
                                            size={19}
                                            className=""
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              {/* {!hasTimesheet && ( */}
                              {lastAction !== null && (
                                <div
                                  className={`h-[100%] cursor-auto w-auto ps-2 pe-3 rounded-tr-md absolute left-[101%] top-[1.375rem] -translate-y-1/2 bg-gray-400 justify-start items-center gap-2 hidden z-10 ${
                                    // (t1.isDisabled === true) ||
                                    hasPushTimesheet
                                      ? "group-hover/openIoconBox:hidden"
                                      : "group-hover/openIoconBox:flex"
                                    }`}
                                >
                                  <button
                                    onClick={() =>
                                      toggleClickShow(t1.timeSheetId, t1.date)
                                    }
                                    disabled={
                                      hasPushTimesheet ||
                                      // t1.timeSpent === 0 ||
                                      hasApprovedTimesheet
                                    }
                                  >
                                    <Icons
                                      name="comment"
                                      variant="stroke"
                                      size={14}
                                      className={
                                        // t1.timeSpent === 0 ||
                                        hasApprovedTimesheet
                                          ? "[&>svg>path]:fill-gray-700"
                                          : // : "[&>svg>path]:fill-green-100"
                                          t1?.comments?.length > 0
                                            ? "[&>svg>path]:fill-green-100"
                                            : "[&>svg>path]:stroke-green-100 [&>svg>path]:fill-gray-400"

                                        // showClickShow
                                        //   ? "[&>svg>path]:fill-green-100"
                                        //   : "hover:[&>svg>path]:fill-green-100"
                                      }
                                    />
                                  </button>
                                  <button
                                    className="group/openModal"
                                    onClick={() =>
                                      handleNotesWrapper(
                                        t.summary,
                                        t.tasksList[0]?.project?.key,
                                        t.tasksList[0]?.project?.id,
                                        t.tasksList[0]?.project?.name,
                                        t.key,
                                        t1.timeSheetId
                                      )
                                    }
                                  >
                                    <Icons
                                      name="small-document"
                                      variant="stroke"
                                      size={14}
                                      className="group-hover/openModal:[&>svg>path]:stroke-green-100"
                                    />
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        ))}

                        <div className="flex justify-end items-center w-[5rem] h-full">
                          <div className="text-400 font-bold text-green-100"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            )}
        </div>
        {getSettingList &&
          getSettingList[0]?.timeSheetApproval === 0 &&
          ((userProfile?.roleName === "Admin" &&
            userProfile?.isReportingManager) ||
            userProfile?.isReportingManager) &&
          lastAction !== null && (
            // !hasTimesheet && (
            <div className="relative flex justify-start items-center px-8 w-full bg-white py-5 gap-4 border-t border-gray-100 rounded-b-md">
              <div className="max-w-full">
                <Tooltip content="Add a comment against time entry." trigger>
                  <Button
                    label="Pushback"
                    onClick={() => setPushBackConfirm(true)}
                    variant="outline"
                    size="large"
                    isDisabled={
                      !comments ||
                      Object.keys(comments).length === 0 ||
                      Object.values(comments).every(
                        (commentArray) => commentArray.length === 0
                      ) ||
                      hasApprovedTimesheet ||
                      hasPushTimesheet
                    }
                  />
                </Tooltip>
              </div>
              {hasApproveTimesheet ? (
                <Button
                  label="Approve"
                  onClick={() => setApproveConfirm(true)}
                  variant="primary"
                  size="large"
                  isDisabled={hasPushTimesheet}
                />
              ) : (
                <Button
                  label="Approved"
                  onClick={function noRefCheck() { }}
                  variant="tertiary"
                  size="large"
                  className="!cursor-auto hover:!shadow-0 !font-bold hover:!bg-green-100"
                />
              )}
              {hasPushTimesheet && (
                <div className="flex justify-end items-center gap-2">
                  <div className="text-400 font-medium text-primary-100 italic">
                    Timesheet pushed back on {" "}
                    {formatPushDate(list[0]?.actionTakenAt)}
                  </div>
                </div>
              )}
              {hasApprovedTimesheet && (
                <div className="flex justify-end items-center gap-2">
                  <div className="text-400 font-medium text-gray-700 italic">
                    Timesheet approved on {" "}
                    {formatPushDate(list[0]?.actionTakenAt)}
                  </div>
                </div>
              )}
              {hasSubmittedTimesheet && (
                <div className="flex justify-end items-center gap-2">
                  <div className="text-400 font-medium text-gray-700 italic">
                    Timesheet submitted on {" "}
                    {formatPushDate(list[0]?.actionTakenAt)}
                  </div>
                </div>
              )}
            </div>
          )}
      </div>

      {addTask && (
        <AddTaskModal
          onClose={() => setAddTask(false)}
          userDetail={id}
          getLists={getteambyList}
          setAddTask={setAddTask}
          //startDate={startOfWeeks}
          startDate={startDate}
          endDate={endDate}
          type="Admin"
        />
      )}

      {showNotification && (
        <Notification
          type="warning"
          message="Oops! You cannot add time in this task, as per your team policy."
        />
      )}

      {showNotification1 && (
        <Notification
          type="warning"
          message="You cannot add time to this task as this task is closed by the administrator."
        />
      )}

      {showNotificationLock && (
        <Notification
          type="warning"
          message="Project Locked: Administrator Has Restricted Time Logging."
        />
      )}

      {singleNote && (
        <SingleMemberTaskViewNoteModal
          onClose={() => setSingleNote(false)}
          summary={noteDetails.summary}
          projectKey={noteDetails.projectKey}
          projectId={noteDetails.projectId}
          projectName={noteDetails.projectName}
          taskKey={noteDetails.key}
          timesheetId={noteDetails.timesheetId}
          userDetail={userDetail}
        />
      )}

      {pushBackConfirm && (
        <PushBackConfirmation
          onClose={() => setPushBackConfirm(false)}
          getteambyList={getteambyList}
          startDate={startDate}
          endDate={endDate}
          id={id}
          setPushBackConfirm={setPushBackConfirm}
          comments={comments}
          timesheetId={timesheetId}
          userLists={userLists}
          setIsPushback={setIsPushback}
          setShowClickShow={setShowClickShow}
        />
      )}

      {approveConfirm && (
        <ApproveConfirmation
          onClose={() => setApproveConfirm(false)}
          setIsSubmitted={setIsSubmitted}
          getteambyList={getteambyList}
          startDate={startDate}
          endDate={endDate}
          id={id}
          setApproveConfirm={setApproveConfirm}
          userLists={userLists}
          setShowClickShow={setShowClickShow}
        />
      )}

      {isConfirmationVisible && (
        <ModalDelete
          onCancel={() => {
            setConfirmationVisible(false);
            setCommentId("");
          }}
          onConfirm={(requestType) => {
            if (requestType === "Yes") {
              dispatch(deleteCommentAsync(commentId)).then((res) => {
                getteambyList();
                toast.success(`Comment Deleted Successfully`, TOASTIFY_CONF);
              });
            }
            setConfirmationVisible(false);
            setCommentId("");
          }}
          chldLable="Are you sure you want to delete this Comment? "
        />
      )}
    </div>
  );
};

export default SingleMemberTaskView;
